
export { useEVMContext } from "/home/runner/work/stackd-perps/stackd-perps/packages/vertex-react-client/context/evm/EVMContext.ts"
export { usePrimaryChainVertexClient } from "/home/runner/work/stackd-perps/stackd-perps/packages/vertex-react-client/context/vertexClient/hooks/usePrimaryChainVertexClient.ts"